import axios from 'axios';

export function formatDate(date) {
  let dArr = date.split('-');
  const formatedDate = dArr[2] + '/' + dArr[1] + '/' + dArr[0].substring(0, 4);
  return formatedDate;
}

export function formatCurrencyBRL(value) {
  return Number(value || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

export function formatDurationFromSeconds(seconds) {
  let total = Math.max(0, Math.round(Number(seconds) || 0));
  if (!total) {
    return '-';
  }

  const units = [
    [12 * 30 * 86400, 'a'],
    [30 * 86400, 'm'],
    [86400, 'd'],
    [3600, 'h'],
    [60, 'min'],
    [1, 's']
  ];

  const parts = [];
  units.forEach(([size, label]) => {
    const value = Math.floor(total / size);
    if (value) {
      parts.push(value + label);
      total %= size;
    }
  });

  return parts.length ? parts.join(' ') : '-';
}

export function validCep(cep) {
  const cepTest = /[0-9]{5}-[\d]{3}/.test(cep);
  return cepTest;
}

export async function viaCep(cep) {
  let infosCepTemp = {};
  let clearCep;
  clearCep = cep.replace('-', '');
  infosCepTemp = await axios.get(`https://viacep.com.br/ws/${clearCep}/json/`);
  if (infosCepTemp) {
    const infosCep = {
      rua: infosCepTemp.data.logradouro,
      cidade: infosCepTemp.data.localidade,
      estado: infosCepTemp.data.uf,
      bairro: infosCepTemp.data.bairro,
      codibge: infosCepTemp.data.ibge
    };
    return infosCep;
  }
  return false;
}

export async function viaCNPJ(cnpj) {
  const cnpjNumber = cnpj.replace(/[^\d]+/g, '');

  const infosFetchCNPJ = await axios.get(`https://publica.cnpj.ws/cnpj/${cnpjNumber}`);

  if (!infosFetchCNPJ.data.error) {
    const infosCNPJ = {
      nome: infosFetchCNPJ.data['razao_social'],
      nomefantasia: infosFetchCNPJ.data['nome_fantasia']
    };
    return infosCNPJ;
  }
  return false;
}

export function formatCnpjCpf(value) {
  const cnpjCpf = value.replace(/\D/g, '');
  if (cnpjCpf.length === 11) {
    return cnpjCpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4');
  }
  return cnpjCpf.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, '$1.$2.$3/$4-$5');
}

export function validateCPF(cpf) {
  if (typeof cpf !== 'string') {
    return false;
  }
  cpf = cpf.replace(/[\s.-]*/gim, '');
  if (
    !cpf ||
    cpf.length !== 11 ||
    cpf === '00000000000' ||
    cpf === '11111111111' ||
    cpf === '22222222222' ||
    cpf === '33333333333' ||
    cpf === '44444444444' ||
    cpf === '55555555555' ||
    cpf === '66666666666' ||
    cpf === '77777777777' ||
    cpf === '88888888888' ||
    cpf === '99999999999'
  ) {
    return false;
  }
  let soma = 0;
  let resto;
  for (let i = 1; i <= 9; i++) {
    // eslint-disable-next-line radix
    soma += parseInt(cpf.substring(i - 1, i)) * (11 - i);
  }
  resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) {
    resto = 0;
  }
  // eslint-disable-next-line radix
  if (resto !== parseInt(cpf.substring(9, 10))) {
    return false;
  }
  soma = 0;
  for (let i = 1; i <= 10; i++) {
    // eslint-disable-next-line radix
    soma += parseInt(cpf.substring(i - 1, i)) * (12 - i);
  }
  resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) {
    resto = 0;
  }
  // eslint-disable-next-line radix
  if (resto !== parseInt(cpf.substring(10, 11))) {
    return false;
  }
  return true;
}

export function validateCNPJ(cnpj) {
  if (!cnpj) return false;

  // 1. Remove formatação e garante que tudo seja maiúsculo
  cnpj = cnpj
    .toString()
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, '');

  if (cnpj.length !== 14) return false;

  // 2. Elimina sequências idênticas inválidas
  if (/^([A-Z0-9])\1{13}$/.test(cnpj)) return false;

  // 3. Função de conversão da Receita Federal (ASCII - 48)
  const obterValorPosicao = (caractere) => {
    return caractere.charCodeAt(0) - 48;
  };

  // 4. Validação do Primeiro Dígito Verificador
  const pesosDV1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  let soma = 0;

  for (let i = 0; i < 12; i++) {
    soma += obterValorPosicao(cnpj.charAt(i)) * pesosDV1[i];
  }

  let resto = soma % 11;
  let resultado = resto < 2 ? 0 : 11 - resto;
  if (resultado !== parseInt(cnpj.charAt(12), 10)) return false;

  // 5. Validação do Segundo Dígito Verificador
  const pesosDV2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  soma = 0;

  for (let i = 0; i < 13; i++) {
    soma += obterValorPosicao(cnpj.charAt(i)) * pesosDV2[i];
  }

  resto = soma % 11;
  resultado = resto < 2 ? 0 : 11 - resto;
  if (resultado !== parseInt(cnpj.charAt(13), 10)) return false;

  return true;
}

export function removeAccents(str) {
  let with_accent = 'ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝŔÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿŕ';
  let no_acento = 'AAAAAAACEEEEIIIIDNOOOOOOUUUUYRsBaaaaaaaceeeeiiiionoooooouuuuybyr';
  let newstr = '';
  for (let i = 0; i < str.length; i++) {
    let trade = false;
    for (let a = 0; a < with_accent.length; a++) {
      if (str.substr(i, 1) == with_accent.substr(a, 1)) {
        newstr += no_acento.substr(a, 1);
        trade = true;
        break;
      }
    }
    if (!trade) {
      newstr += str.substr(i, 1);
    }
  }
  return newstr;
}

export function validEmail(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}
